var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgYoutubeIcon = function SvgYoutubeIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M26.983 3.018A3.45 3.45 0 0 0 24.555.59C22.399 0 13.775 0 13.775 0S5.151 0 2.995.568a3.52 3.52 0 0 0-2.428 2.45C0 5.174 0 9.645 0 9.645s0 4.493.567 6.627A3.45 3.45 0 0 0 2.996 18.7c2.178.59 10.78.59 10.78.59s8.623 0 10.779-.567a3.45 3.45 0 0 0 2.428-2.429c.568-2.156.568-6.626.568-6.626s.022-4.494-.568-6.65"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m11.03 13.775 7.17-4.13-7.17-4.13z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgYoutubeIcon);
export default ForwardRef;